import Enumerable from "linq";
import { RelationTranslator } from "./RelationTranslator";
import { IXElementContentsObjectBean, IXElementContentsObjectRelationalItemBean, IXElementContentsObjectRelationalBean } from "../../../beans";
import { IDateCalculateBehavior, IDateCalculateObject, IDateCalculateNumber } from "../../../../../../../documaker/domain/format/objects";

export class DateCalculateBehaviorTranslator {
  constructor() {
    this.relationalItems = new RelationTranslator("calculate");
  }

  from(bean: IXElementContentsObjectBean): IDateCalculateBehavior {
    return {
      items: this.relationalItems.from(
        bean,
        is => (Enumerable.from(is).select(i => {
          const isObject = (i["@item-type"] === "1");
          return {
            isObject,
            reference: isObject
              ? this.itemAsObject.from(i)
              : this.itemAsNumber.from(i),
          };
        }).toArray()),
        []),
    };
  }

  to(object: IDateCalculateBehavior): IXElementContentsObjectRelationalBean {
    return this.relationalItems.to(
      Enumerable.from(object.items)
        .select(r => r.isObject 
          ? this.itemAsObject.to(r.reference as IDateCalculateObject) 
          : this.itemAsNumber.to(r.reference as IDateCalculateNumber)).toArray());
  }

  private readonly itemAsObject = {
   from: (bean: IXElementContentsObjectRelationalItemBean): IDateCalculateObject => ({
    itemType: bean["@item-type"],
    type: bean["@type"],
    key: bean["@key"],
    option: bean["@option"],
    operator: bean["@operator"],
   }),
   to: (object: IDateCalculateObject): IXElementContentsObjectRelationalItemBean => ({
    "@item-type": object.itemType,
    "@type": object.type,
    "@key": object.key,
    "@option": object.option,
    "@operator": object.operator,
   }),
  };

  private readonly itemAsNumber = {
    from: (bean: IXElementContentsObjectRelationalItemBean): IDateCalculateNumber => ({
     itemType: bean["@item-type"],
     option: bean["@option"],
     value: parseInt(bean["@value"].toString(), 10),
     operator: bean["@operator"],
    }),
    to: (object: IDateCalculateNumber): IXElementContentsObjectRelationalItemBean => ({
      "@item-type": object.itemType,
      "@option": object.option,
      "@value": object.value.toString(),
      "@operator": object.operator,
    }),
   };

  private readonly relationalItems: RelationTranslator;
}
